import { combineReducers } from 'redux';

import * as navigation from './navigation';
import * as document from './document';
import * as clientSearch from './clientSearch';
import * as podcast from './podcast';
import * as dismissible from './dismissible';
import * as aiChat from './aiChat';
import * as apiClients from './apiClients';

const all = {
  navigation: navigation.reducer,
  document: document.reducer,
  clientSearch: clientSearch.reducer,
  podcast: podcast.reducer,
  dismissible: dismissible.reducer,
  aiChat: aiChat.reducer,
  apiClients: apiClients.reducer,
};
const combined = combineReducers(all);

export const reducers = {
  all,
  combined,
};
